import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Link, Typography } from '@zapier/design-system';
export const CssVars = {
    flexDirection: '--UniversalFooter__HelpfulLinks-flex-direction',
    justifyContent: '--UniversalFooter__HelpfulLinks-justify-content',
};
const Styles = {
    root: css `
    display: flex;
    flex-direction: var(${CssVars.flexDirection}, column);
    justify-content: var(${CssVars.justifyContent}, center);
    text-align: center;
    flex-wrap: wrap;
    column-gap: 12.5px;
    row-gap: 10px;
  `,
    link: css `
    ${Typography.paragraph3Semibold};
    color: ${Colors.neutral700} !important;
    // For browsers that don't yet support Flexbox gap
    padding: 0 5px;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    &:hover,
    &:focus {
      color: ${Colors.blue} !important;
      outline: none;
    }
  `,
};
export const HelpfulLinks = (props) => {
    const { links = [
        { text: 'Pricing', href: '/pricing' },
        { text: 'Help', href: '/help' },
        { text: 'Developer Platform', href: '/platform' },
        { text: 'Press', href: '/press' },
        { text: 'Jobs', href: '/jobs/' },
        {
            text: 'Zapier for Companies',
            href: '/teams-companies',
        },
        { text: 'Transfer', href: '/transfer' },
    ], } = props;
    const linkNodes = links.map((link) => {
        return (isolateComponent("li", { key: link.text },
            isolateComponent(Link, { color: null, css: Styles.link, href: link.href }, link.text)));
    });
    return isolateComponent("ul", { css: Styles.root }, linkNodes);
};
//# sourceMappingURL=HelpfulLinks.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
